import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { BankAccountAction } from "../../../Common/PaymentsIn/BankAccount/BankAccountAction";
import { inUseBankAccountForApply } from "../../../Common/PaymentsIn/BankAccount/BankAccountHelper";
import { RegularPayment } from "../../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { SinglePayment } from "../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { PaymentType, processTypeEnum } from "../../../Common/Resource/Contents";

interface IWrapCashPaymentsInProps extends IProcessComponentProps {
    data: ApplyModel;
}

interface IWrapCashPaymentsInState {}

export class WrapCashPaymentsIn extends ProcessComponent<IWrapCashPaymentsInProps, IWrapCashPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            type: key,
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            clientInfo: data.ClientDetails,
            bankAccounts: data.AllBankAccounts,
            bankAccountInstructions: data.BankAccountInstructions,
            isReview: isReview,
            onSaveNewBankAccountInstruction: (bankAccountInstruction) => {
                bankAccountInstruction.OwnerHierarchyId = data.OwnerHierarchyId;
                BankAccountAction.saveBankInstruction(
                    bankAccountInstruction,
                    data.ClientDetails?.ActorId,
                    processTypeEnum.NewBusiness,
                    (savedBankAccountInstruction) => {
                        const changes = [...data.BankAccountInstructions, ...[savedBankAccountInstruction]];
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }
                );
            },
            onRemoveBankAccountInstruction: (bankAccountInstruction) => {
                BankAccountAction.removeBankInstruction(bankAccountInstruction, () => {
                    const changes = (data.BankAccountInstructions || []).filter(
                        (x) => x.AccountNumber != bankAccountInstruction.AccountNumber
                    );
                    this.onDataChange(onChange, { BankAccountInstructions: changes }, data);
                });
            },
            inUseBankAccountInstruction: inUseBankAccountForApply(data),
        };
    };

    public render(): JSX.Element {
        const { ClientDetails, AllBankAccounts, BankAccountInstructions, IsNBEC } = this.props.data;
        return (
            <div>
                <h2>Payments in</h2>
                <SinglePayment
                    {...this.getProps("WrapCashModel")}
                    clientInfo={ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.WrapCash}
                    bankAccounts={AllBankAccounts}
                    hasPaymentMethod={true}
                    bankAccountInstructions={BankAccountInstructions}
                    processType={processTypeEnum.NewBusiness}
                    excludeWrapCash={true}
                />
                <hr />
                {!this.props.data.IsNBEC && (
                    <RegularPayment
                        {...this.getProps("WrapCashModel")}
                        clientInfo={this.props.data.ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        subAccountType={SubAccountType.WrapCash}
                        hasContinue={true}
                        hasIndexation={false}
                        hasPaymentMethod={true}
                        processType={processTypeEnum.NewBusiness}
                    />
                )}
            </div>
        );
    }
}
